import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/call-routing')({
    component: CallRoutingPage,
});

// Call routing was folded into the Phone setup pages; the route remains as a
// redirect for old links.
function CallRoutingPage() {
    return <Navigate to="/settings/phone-instructions" replace={true} />;
}
